import React from "react";
import { Modal } from "antd";
import { getKWaiAuthUrl, getPddAuthUrlV2, getTaobaoAuthUrl, getXHSAuthUrl } from "@/services/api/ewaybillAuth";
import AutoLoadingButton from "@/components/AutoLoadingButton";
import { useModalStore } from "@/hooks/Modal/hooks";
import JDAuthButton from "../JDAuthButton";
import DyEwaybillAuthButton from "./DyEwaybillAuthButton";

interface OperationContainerProps {
  onSync?(): void;

  onRefresh?(): void;
}

const OperationContainer: React.FC<OperationContainerProps> = function (props) {
  const { onSync, onRefresh } = props;

  const modalStore = useModalStore();

  return (
    <div className="mb10">
      {/* <AutoLoadingButton
        className="mr15 btn-success"
        onClick={() => {
          modalStore.openModal(AddOfficialAccountModal, {
            refresh: onRefresh,
          });
        }}
      >
        添加网点电子面单账号
      </AutoLoadingButton> */}

      <AutoLoadingButton
        className="mr15 btn-success"
        onClick={() => {
          Modal.confirm({
            closable: false,
            title: "授权淘宝菜鸟账号",
            content: (
              <div className="text-black" style={{ fontSize: 18 }}>
                请点击下面的“登陆授权（主账号）”按钮，然后使用已开通电子面单的淘宝【主账号】登录授权
              </div>
            ),
            okText: "登录授权（主账号）",
            async onOk() {
              const { url } = await getTaobaoAuthUrl();
              window.location.href = url;
            },
          });
        }}
      >
        授权淘宝菜鸟平台账号
      </AutoLoadingButton>

      <JDAuthButton />

      <AutoLoadingButton
        className="mr15 btn-success"
        onClick={async () => {
          const { url } = await getPddAuthUrlV2();

          window.location.href = url;
        }}
      >
        授权拼多多平台账号
      </AutoLoadingButton>

      <DyEwaybillAuthButton />

      <AutoLoadingButton
        className="mr15 btn-success"
        onClick={async () => {
          const { url } = await getKWaiAuthUrl();

          window.location.href = url;
        }}
      >
        授权使用快手电子面单
      </AutoLoadingButton>

      <AutoLoadingButton
        className="mr15 btn-success"
        onClick={async () => {
          const { url } = await getXHSAuthUrl();

          window.location.href = url;
        }}
      >
        授权使用小红书电子面单
      </AutoLoadingButton>

      <AutoLoadingButton className="mr15 btn-functional" onClick={onSync}>
        同步电子面单账号
      </AutoLoadingButton>
    </div>
  );
};

export default React.memo(OperationContainer);
